"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const format_1 = __importDefault(require("date-fns/format"));
const getTime_1 = __importDefault(require("date-fns/getTime"));
const zonedTimeToUtc_1 = __importDefault(require("date-fns-tz/zonedTimeToUtc"));
const KSA_TIMEZONE_1 = __importDefault(require("../../../constants/date/KSA_TIMEZONE"));
/**
 * Return GMT Epoch timestamp w.r.t KSA timezone for the Date and time passed
 * KSA = GMT + 3:00
 * @param {Date} date
 * @param {string} time
 * @returns {Number} GMT Epoch time stamp i.e Unix timestamp / 1000
 */
function getTimeStampForDateTime(date, time) {
    const formattedDate = (0, format_1.default)(date, 'MMMM dd, yyyy'); // eg. 'April 12, 2021'
    // const dateTime = new Date(`${formattedDate} ${time} GMT+03:00`);
    const dateTime = new Date(`${formattedDate} ${time}`);
    const saudiDateTime = (0, zonedTimeToUtc_1.default)(dateTime, KSA_TIMEZONE_1.default); // convert to GMT w.r.t KSA timezone
    return Math.floor((0, getTime_1.default)(saudiDateTime) / 1000);
}
exports.default = getTimeStampForDateTime;
